import { render, staticRenderFns } from "./AuditDetail.vue?vue&type=template&id=a68ab60a&scoped=true"
import script from "./AuditDetail.vue?vue&type=script&lang=ts"
export * from "./AuditDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68ab60a",
  null
  
)

export default component.exports